
import React from 'react';


import {connect} from 'react-redux';
import html2pdf from 'html2pdf.js';
import LoftyDropdownComponent from '../../components/loftydropdowncomponent';
import LoftyCountDown from '../../components/loftycountdown';
import LoftyCartCarousel from '../../components/loftycartcarousel';
import LoftyThreeCarousel from '../../components/loftythreecarousel';
import LoftyCarouselPlugin from '../../components/LoftyCarouselPlugin';
import LoftyLeaftMap from '../../components/loftyLeaftMaps';
import LoftyAnimatedParticleBackground from '../../components/loftyAnimatedParticleBackground';
import LoftyGoogleLoginComponent from '../../components/loftyGoogleLoginComponent';

import { addLoftyToken, deleteLoftytoken } from '../../actions/auth.actions';


import './principalutlvg.scss';






const Pprincipalutlvg = ({
  match,
  history,
  loftytoken,
  loftyuser,
  addLoftyUserApp,
  deleteLoftytokenApp,
  addLoftyTokenApp,
  
}) => {






  
  
  
  

  
  return (
    <div id="id6898dffa8e5aed52dc7b50c0" >

      <div id="ibm6" className="">
      
      <div id="iwqt" className="">
      
      <div id="incm3" className="">
      
        <a
          target=""
          className=""
          id="ixtof"
          href="/"
        >
          
      <img
        className=""
        id="iwbnr"
        src="https://assetsprojects.s3.amazonaws.com/404pziime609rgd.png"
        alt="undefined"
      />
      
        </a>
        
      <div id="id16m" className="">
      
        <a
          target=""
          className="link-menu link-activo "
          id="ikbb5"
          href="/"
        >
          
    <div id="i5zvy" className="">
    <>Inicio</>
    </div>
    
        </a>
        
        <a
          target=""
          className="link-menu "
          id="iaz2n"
          href="/informacion"
        >
          
    <div id="igsoz" className="">
    <>Nuestra información</>
    </div>
    
        </a>
        
        <a
          target=""
          className="link-menu "
          id="ijoly"
          href="/quehacemos"
        >
          
    <div id="i1fz4" className="">
    <>Que Hacemos</>
    </div>
    
        </a>
        
        <a
          target=""
          className="link-menu "
          id="i6wju"
          href="/guiadigital"
        >
          
    <div id="iu68s" className="">
    <>Guía Digital</>
    </div>
    
        </a>
        
        <a
          target=""
          className="link-menu "
          id="iqw23"
          href="/contacto"
        >
          
    <div id="i97f5" className="">
    <>Contacto</>
    </div>
    
        </a>
        
        <a
          target=""
          className="link-menu "
          id="ijp0h7"
          href="https://hackathon.sustentahonduras.org/"
        >
          
    <div id="i61l04" className="">
    <>Hackathon</>
    </div>
    
        </a>
        
      </div>
      
      </div>
      
      </div>
      
      <div id="i2zb" className="">
      
      <div
        id="iqf8z"
        className=""
        data-aos="fade-down"
        data-aos-duration="1200"
      >
      
      <div id="it9wf" className="">
      
      <img
        className=""
        id="imqzc"
        src="https://assetsprojects.s3.amazonaws.com/404pziime60gerq.png"
        alt="undefined"
      />
      
      <img
        className=""
        id="idl0f"
        src="https://assetsprojects.s3.amazonaws.com/404pziime60fb65.png"
        alt="undefined"
      />
      
      </div>
      
      <div id="izgm8" className="">
      
      <div id="ix4ee" className="">
      
      <div className="" id="iqji1">
        <>Jóvenes al Voto</>
      </div>
      
      <div className="" id="i9tfg">
        <>Creemos que tu voz cuenta y que el cambio empieza contigo. Nuestro objetivo es guiarte paso a paso para que entiendas cómo, cuándo y dónde votar, de forma clara y sencilla. Aquí encontrarás información práctica, consejos y recursos diseñados especialmente para jóvenes como tú, que quieren marcar la diferencia en su comunidad y en el país.</>
      </div>
      
      <div id="izguv" className="">
      
        <a
          target=""
          className="boton-principal "
          id="imc7h4"
          href="/guiadigital"
        >
          
    <div id="id1pi" className="">
    <>GUIA DIGITAL</>
    </div>
    
        </a>
        
      </div>
      
      </div>
      
      </div>
      
      <div id="i9dch" className="">
      
      </div>
      
      </div>
      
      </div>
      
      <div id="ib7vm" className="">
      
      <div className="" id="ifhej">
        <>Nuestras Alianzas</>
      </div>
      
      <div id="i2r5z" className="">
      
      <div id="ii5r3" className="">
      
      <div
        id="iyumz"
        className="tarjeta-alianza "
        data-aos="fade-down"
        data-aos-duration="1200"
      >
      
      <div id="i2m2d" className="">
      
      <img
        className=""
        id="ivy5z"
        src="https://assetsprojects.s3.amazonaws.com/404pziime613sze.png"
        alt="undefined"
      />
      
      </div>
      
      <div id="iasvz" className="">
      
      <div className="" id="i9ois">
        <>Sustenta honduras</>
      </div>
      
      </div>
      
      </div>
      
      </div>
      
      </div>
      
      <div id="ieust" className="">
      
      <div
        id="iru3z"
        className=""
        data-aos="fade-down"
        data-aos-duration="1200"
      >
      
      <div id="ijudl" className="">
      
      <img
        className=""
        id="ilpg3"
        src="https://assetsprojects.s3.amazonaws.com/404pziime61c1ox.png"
        alt="undefined"
      />
      
      </div>
      
      <div id="izegh" className="">
      
      <div className="" id="ikajw">
        <>¡Estamos aquí para escucharte! 💬</>
      </div>
      
      <div className="" id="igadf">
        <>Si quieres más información, tienes preguntas sobre</>
      <br className="" id="" />
      <>cómo votar o deseas ser parte del movimiento,</>
      </div>
      
      <div className="" id="i1tt6">
        <> Tu voz cuenta. Tu mensaje importa.</>
      </div>
      
      <div id="ic39m" className="">
      
        <a
          target=""
          className="boton-principal "
          id="iuoqj"
          href="/contacto"
        >
          
    <div id="i95f4" className="">
    <>CONTÁCTANOS</>
    </div>
    
        </a>
        
      </div>
      
      </div>
      
      </div>
      
      </div>
      
      </div>
      
      <div id="inzf4" className="">
      
      <div id="i8cpm" className="">
      
      <div className="" id="iy2lc">
        <>FINANCIAMIENTO</>
      </div>
      
      <div className="" id="i4771">
        <>Fondo de Apoyo a la Observación Electoral de Naciones Unidas</>
      </div>
      
      </div>
      
      <img
        className=""
        id="iyw2r"
        src="https://assetsprojects.s3.amazonaws.com/404pziime616jf3.png"
        alt="undefined"
      />
      
      </div>
      
      <div id="iafpfe" className="">
      
      <div
        id="ijn2v1"
        className=""
        data-aos="fade-down"
        data-aos-duration="1200"
      >
      
      <div id="ijzqaf" className="">
      
      <img
        className=""
        id="ikglul"
        src="https://assetsprojects.s3.amazonaws.com/404pziimhxz4lh8.png"
        alt="undefined"
      />
      
      <img
        className=""
        id="ijxmhf"
        src="https://assetsprojects.s3.amazonaws.com/404pziimhxz3uu9.png"
        alt="undefined"
      />
      
      <img
        className=""
        id="iwe6hy"
        src="https://assetsprojects.s3.amazonaws.com/404pziime613sze.png"
        alt="undefined"
      />
      
      </div>
      
      <div id="ikncwl" className="">
      
      <div className="" id="i3299b">
        <>Jóvenes al Voto nace como uno de los diez proyectos ganadores del Hackathon de Transparencia Electoral, organizado por Sustenta Honduras en colaboración con la Universidad Tecnológica Centroamericana (UNITEC), campus San Pedro Sula. Este evento se llevó a cabo en el marco de los Subsidios de Bajo Valor del proyecto EUROELECT-H, financiado por la Unión Europea y con implementación técnica del Programa de las Naciones Unidas para el Desarrollo (PNUD) en Honduras.</>
      <br className="" id="" />
      
      </div>
      
      </div>
      
      </div>
      
      </div>
      
      <div id="iss5" className="">
      
      <div id="izyl6q" className="">
      
      <div className="" id="iwoln1">
        <>Todos los Derechos Reservadost © 2025 Jovenes al Voto</>
      </div>
      
      </div>
      
      </div>
      
      </div>
      
</div>
  );
}

const mapStateToProps = (state) => state.auth;

const mapDispatchToProps = (dispatch) => ({
 addLoftyTokenApp: (data) => dispatch(addLoftyToken(data)),
 deleteLoftytokenApp: () => dispatch(deleteLoftytoken()),
});


export default connect(mapStateToProps, mapDispatchToProps)(Pprincipalutlvg);
  